const {
  REACT_APP_SUBSCRIPTIONS_ENABLED = 'false',
  REACT_APP_BROKER_NAME = '',
} = process.env;

export const moduleEnableSubscription =
  REACT_APP_SUBSCRIPTIONS_ENABLED === 'true' ? true : false;

export const moduleBrokerName = REACT_APP_BROKER_NAME;
